var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#35CCFF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BAFF"
    },
    d: "M512,256c0-12.636-0.931-25.054-2.7-37.2L418.5,128l-4.735,6.265L381.5,102l-37.98,183.02L160.5,102 l-67,293l112.01,112.01c16.324,3.266,33.205,4.99,50.49,4.99C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 128,
    style: {
      fill: "#FFFFFF"
    },
    width: 325,
    height: 267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.95,
    y: 128,
    style: {
      fill: "#E0E0E0"
    },
    width: 162.55,
    height: 267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.5,
    y: 128,
    style: {
      fill: "#FF6838"
    },
    width: 325,
    height: 59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.95,
    y: 128,
    style: {
      fill: "#AE4E32"
    },
    width: 162.55,
    height: 59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 136,
    cy: 230,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 196,
    cy: 230,
    r: 16
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#97CC52"
    },
    cx: 256,
    cy: 230,
    r: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60C344"
    },
    d: "M256,214c-0.016,0-0.031,0.002-0.048,0.002v31.995c0.016,0,0.031,0.002,0.048,0.002 c8.836,0,16-7.164,16-16S264.836,214,256,214z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#60C344"
    },
    cx: 376,
    cy: 230,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#60C344"
    },
    cx: 316,
    cy: 230,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#97CC52"
    },
    cx: 136,
    cy: 285.5,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#97CC52"
    },
    cx: 196,
    cy: 285.5,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#97CC52"
    },
    cx: 256,
    cy: 285.5,
    r: 16
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60C344"
    },
    d: "M256,269.5c-0.016,0-0.031,0.002-0.048,0.002v31.995c0.016,0,0.031,0.002,0.048,0.002 c8.836,0,16-7.164,16-16S264.836,269.5,256,269.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0C0C0"
    },
    cx: 376,
    cy: 285.5,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#60C344"
    },
    cx: 316,
    cy: 285.5,
    r: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 136,
    cy: 341,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 196,
    cy: 341,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 256,
    cy: 341,
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C0C0"
    },
    d: "M256,325c-0.016,0-0.031,0.002-0.048,0.002v31.995c0.016,0,0.031,0.002,0.048,0.002 c8.836,0,16-7.164,16-16S264.836,325,256,325z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0C0C0"
    },
    cx: 376,
    cy: 341,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0C0C0"
    },
    cx: 316,
    cy: 341,
    r: 16
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 102,
    style: {
      fill: "#FFCF35"
    },
    width: 30,
    height: 59
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.5,
    y: 102,
    style: {
      fill: "#FFB344"
    },
    width: 30,
    height: 59
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e3b4ad311efb47c95f46e0e1a4c99c9c.svg";
export { ForwardRef as ReactComponent };